"use client";

import type { MouseEvent } from "react";
import { Hero as BumbleHero } from "@bumble/ui-kit";
import { useMediaQuery } from "@/lib/hooks/useMediaQuery";
import { isExternalUrl } from "@/lib/utils/isExternalUrl";
const PLACEHOLDER_IMAGE = "/assets/placeholder-background.png";
export default function Hero({
  data
}: any) {
  const {
    title = "",
    copy = "",
    imageDesktop,
    imageMobile,
    imageTablet,
    textColour = "black",
    cta
  } = data;
  const isMobile = useMediaQuery(768);
  const isTablet = useMediaQuery(1024);
  const isCtaExternal = isExternalUrl(cta?.link);
  const bgImage = {
    url: isMobile ? imageMobile?.url || imageDesktop?.url : isTablet ? imageTablet?.url || imageDesktop?.url : imageDesktop?.url,
    alt: isMobile ? imageMobile?.alt || imageDesktop?.alt : isTablet ? imageTablet?.alt || imageDesktop?.alt : imageDesktop?.alt
  };
  return <BumbleHero backgroundImageSrc={bgImage?.url || PLACEHOLDER_IMAGE} backgroundImageAlt={bgImage?.alt ?? "Placeholder image"} backgroundColor={undefined} words={undefined} descriptionText={undefined} animation={undefined} animationCards={undefined} ctaBox={{
    description: copy ?? "",
    title: title ?? "",
    cta: {
      text: cta?.text ?? "",
      href: cta?.link ?? "",
      onClick: isCtaExternal ? (event: MouseEvent) => {
        event.preventDefault();
        window.open(cta?.link, "_blank", "noopener,noreferrer");
      } : () => {}
    }
  }} textColor={textColour === "black" ? "default" : "inverse"} variant="full-width-image" overlay="" />;
}